import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '',  loadComponent: () => import('./home/home.component').then(m => m.HomeComponent), data: { title: 'mojotime'}}, 
    { path: 'home', loadComponent: () => import('./home/home.component').then(m => m.HomeComponent), data: { title: 'mojotime'}},
    { path: 'news/:catid/:nid', loadComponent: () => import('./news/news.component').then(m => m.NewsComponent), data: { title: 'mojotimesnews'}},
    { path: 'news/:catid', loadComponent: () => import('./news/news.component').then(m => m.NewsComponent), data: { title: 'mojotimesnews'}},
     { path: '**', loadComponent: () => import('./home/home.component').then(m => m.HomeComponent), data: { title: 'mojotime'}}
];
